/* 🤖 this file was generated by svg-to-ts */
export const siriusBell: {
  name: 'bell';
  data: string;
} = {
  name: 'bell',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M20.7 16.49c-.553-.956-1.219-2.774-1.219-5.99v-.666c0-4.153-3.328-7.556-7.425-7.584H12a7.49 7.49 0 0 0-7.481 7.5v.75c0 3.216-.666 5.034-1.22 5.99a1.5 1.5 0 0 0 1.295 2.26H8.25a3.75 3.75 0 1 0 7.5 0h3.656a1.49 1.49 0 0 0 1.5-1.506 1.519 1.519 0 0 0-.206-.753ZM12 21a2.26 2.26 0 0 1-2.25-2.25h4.5A2.26 2.26 0 0 1 12 21Zm-7.406-3.75c.647-1.125 1.425-3.197 1.425-6.75v-.75a5.981 5.981 0 0 1 5.98-6h.048c3.272.019 5.934 2.756 5.934 6.084v.666c0 3.553.778 5.625 1.425 6.75H4.594Z" fill="currentColor"/></svg>`
};
